import { render, staticRenderFns } from "./CategoryMenuItem.vue?vue&type=template&id=455c9d7b&scoped=true&"
import script from "./CategoryMenuItem.vue?vue&type=script&lang=js&"
export * from "./CategoryMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMenuItem.vue?vue&type=style&index=0&id=455c9d7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455c9d7b",
  null
  
)

export default component.exports